export const COPILOT_THEME_SETTING_NAME = 'copilotthemeoptions';
